import { AxiosError } from 'axios';

type AudienceStudioErrorBody = {
  errors?: string[] | Record<string, string[]>;
  audienceSize?: number;
};

export function getAudienceStudioApiErrorMessage(
  error: unknown,
  fallback: string
): string {
  const axiosError = error as AxiosError<AudienceStudioErrorBody>;
  const errors = axiosError?.response?.data?.errors;

  if (Array.isArray(errors) && errors.length > 0 && typeof errors[0] === 'string') {
    return errors[0];
  }

  if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
    const firstKey = Object.keys(errors)[0];
    const firstList = firstKey
      ? (errors as Record<string, string[]>)[firstKey]
      : undefined;
    if (Array.isArray(firstList) && firstList.length > 0) {
      return firstList[0];
    }
  }

  return fallback;
}

export function getAudienceStudioApiAudienceSize(error: unknown): number | null {
  const axiosError = error as AxiosError<AudienceStudioErrorBody>;
  const audienceSize = axiosError?.response?.data?.audienceSize;
  return typeof audienceSize === 'number' && Number.isFinite(audienceSize)
    ? audienceSize
    : null;
}
